/* eslint-disable brace-style */
import { makeAutoObservable } from 'mobx'
import type { StripeElementsOptionsMode } from '@stripe/stripe-js'
import { ShopRootStore } from 'shop/stores/shopRoot.store'
import {
  CURRENCY_COUNTRY_MAP,
  PAY_BY_BANK_COUNTRIES,
  STIPE_ELEMENT_OPTIONS_DEFAULT,
} from 'constants/paymentSettingShared.constants'

import { PAYMENT_PLANS } from 'constants/pricingPlans.constants'
import {
  StripeElementOptions,
  StripeElementsPayloads,
  StripePaymentElement,
  StripePaymentMethod,
  StripePaymentMethodShop,
} from '../../interfaces/payment-method-interfaces/StripePaymentMethod'

export class ShopPayByBankPaymentMethodStore
  implements StripePaymentMethod, StripePaymentMethodShop, StripeElementOptions, StripePaymentElement
{
  storeName = 'ShopPayByBankPaymentMethodStore'
  root: ShopRootStore = null

  constructor(root: ShopRootStore) {
    this.root = root

    makeAutoObservable(this)
  }

  isAppActive() {
    return this.root.experimentsStore.getFeatureGate('pay_by_bank_method')?.value
  }

  isAvailable = (activeCountry: string, currency: string): boolean =>
    PAY_BY_BANK_COUNTRIES.includes((activeCountry || 'DE').toUpperCase()) &&
    CURRENCY_COUNTRY_MAP[currency.toUpperCase()]?.includes(activeCountry)

  getStripeElementPayload = ({
    isDealsPage,
    isManagePage,
  }: {
    isDealsPage: boolean
    isManagePage: boolean
  }): StripeElementsOptionsMode => {
    let store: StripeElementsPayloads = null
    if (isDealsPage) {
      store = this.root.dealsStore
    } else if (isManagePage) {
      store = this.root.ordersStore
    } else {
      store = this.root.paymentStore
    }

    return (
      (store?.getPayByBankStripeElementPayload && store.getPayByBankStripeElementPayload()) ||
      STIPE_ELEMENT_OPTIONS_DEFAULT
    )
  }

  getPaymentElementOptions = () => ({})

  isAvailableForPayerType = () => true

  isAvailableForPricingPlan = ({ withTestPeriod, withCustomStart, pricingPlanForm }) =>
    !withTestPeriod && !withCustomStart && pricingPlanForm === PAYMENT_PLANS.oneTime
}
